<template>
  <el-dialog title="车辆选择"
             :visible.sync="linkDialog"
             width="1200px"
             v-dialogDrag
             class="choose-box">
    <ioc-table ref="crud"
               :data="vechileData"
               :option="carOptions"
               :page="vechilePage"
               @size-change="personChangeSize"
               @current-change="currentChange"
               @search-change="searchList"
               @search-reset="carReset"
               @selection-change="carSelection">
      <!-- 搜索框 自定义 -->
      <template slot="search_personnelType">
        <el-select v-model="personSearch.personnelType"
                   clearable
                   placeholder="请选择"
                   @change="personnelTypeChange">
          <el-option v-for="item in dicData"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </template>
      <template slot="search_departmentName">
        <div style="flex:1;position:relative">
          <el-input placeholder="请选择"
                    style="width:300px;"
                    @click.stop.native="departemntTreeShow"
                    class="bukongObject"
                    clearable
                    @clear="clearDepartment"
                    v-model="queryForm.departmentName"></el-input>
          <div v-if="departmentTree"
               class="tree-container">
            <div style="position:relative;height:100%;overflow-y:auto;">
              <el-tree :props="treeProps"
                       :data="departmentData"
                       :show-checkbox="multiCheck"
                       render-after-expand
                       node-key="areaDevGroupCode"
                       ref="grouptree"
                       @check="setNode">
              </el-tree>
            </div>
            <div style="text-align: center">
              <el-button type="primary"
                         @click="confirmTree">确认</el-button>
              <el-button type="info"
                         @click="cancelTree">取消</el-button>
            </div>
          </div>
        </div>
      </template>
      <template slot="search_visitorVehicleTypeName">
        <el-select v-model="queryForm.visitorVehicleTypeCode"
                   clearable
                   placeholder="请选择">
          <el-option v-for="item in vehicleTypeList"
                     :key="item.visitorVehicleTypeCode"
                     :label="item.visitorVehicleTypeName"
                     :value="item.visitorVehicleTypeCode"> </el-option>
        </el-select>
      </template>
    </ioc-table>
    <el-form :model="authorityForm"
             ref="form"
             label-width="110px"
             :rules="rules">
      <el-row>
        <el-col :span="8">
          <el-form-item label="通行生效时间"
                        prop="effectiveTime">
            <el-date-picker v-model="authorityForm.effectiveTime"
                            type="datetime"
                            placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="通行失效时间"
                        prop="expirationTime">
            <el-date-picker v-model="authorityForm.expirationTime"
                            type="datetime"
                            placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆道闸"
                        prop="carGate">
            <el-select v-model="authorityForm.carGate"
                       multiple
                       collapse-tags
                       placeholder="请选择">
              <el-option v-for="item in treeData"
                         :key="item.thirdDeviceId"
                         :label="item.thirdDeviceName"
                         :value="item.thirdDeviceId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="cancleChoose">取消</el-button>
      <el-button type="primary"
                 @click="confirmChoose">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { api } from "../api";
import utils from '@src/common/utils'
import { Dic, Bus, Dates } from "$utils";
import i18n from "@src/common/lib/i18n";
import carOptions from "../config/carOptions";
import { formatTimeToStr } from "../filter/dateUtils"
export default {
  props: {
    treeData: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      carOptions: carOptions(),
      linkDialog: false,
      vechileData: [],
      vechilePage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      personSearch: {},
      // 授权表单数据
      authorityForm: {
        effectiveTime: Dates.parse(Dates.format(new Date())),
        expirationTime: "2037-12-31 00:00:00",
        carGate: []
      },
      rules: {
        effectiveTime: [
          {
            required: true,
            message: "请选择通行生效时间",
            trigger: "blur",
          },
        ],
        expirationTime: [
          {
            required: true,
            message: "请选择通行失效时间",
            trigger: "blur",
          },
        ],
        carGate: [
          {
            required: true,
            message: "请选择车辆道闸",
            trigger: "change",
          },
        ],
      },
      // 车辆选择弹框选择的车辆ID
      carIds: [],
      queryForm: {
        departmentName: '',
        departmentCodeList: [],
        visitorVehicleTypeCode: ''
      },
      departmentTree: false,
      // 部门树的props
      treeProps: {
        children: "children",
        label: "label",
        isLeaf: "isLeaf",
      },
      multiCheck: true,
      vehicleTypeList: [],
      dicData: [{
        label: '员工',
        value: 1,
      },
      {
        label: '访客',
        value: 2,
      },
      ],
    }
  },
  watch: {
  },
  mounted () {
    this.getVechileList();
    this.getDepartmentTree();
    this.queryVisitorVehicleType();
  },
  methods: {
    personnelTypeChange (val) {
      if (val === 2) {
        // 当车主类型为访客是才会出现访客车辆类型字段
        this.carOptions.column[8].search = true
      } else {
        this.carOptions.column[8].search = false;
      }
    },
    open (id) {
      this.linkDialog = true;
    },
    // 获取访客车辆类型组接口
    queryVisitorVehicleType () {
      this.$fetch(api.vehicle.queryVisitorVehicleType, {}).then((res) => {
        if (res.success) {
          this.vehicleTypeList = res.returnObj;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 获取部门树结构
    getDepartmentTree () {
      const param = {};
      this.$fetch(api.device.departmentTree, param).then((res) => {
        if (res.success) {
          this.departmentData = this.menusDataPro2(res.returnObj);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    //递归部门树结构
    menusDataPro2 (data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.label = item.departmentName;
          entity.value = item.departmentCode;
          entity.isLeaf = !item.subDepartmentList;
          if (item.subDepartmentList && item.subDepartmentList.length) {
            entity.children = self.menusDataPro2(item.subDepartmentList);
          }
          result.push(entity);
        });
        return result;
      }
    },
    departemntTreeShow () {
      this.departmentTree = true
    },
    confirmTree () {
      this.departmentTree = false
    },
    cancelTree () {
      this.departmentTree = false
    },
    setNode (data, list) {
      // console.log('--数据----', data);
      // console.log('===列表==departmentName=', list);
      let checkedCodes = []
      checkedCodes = list.checkedNodes;
      this.queryForm.departmentName = ''
      this.queryForm.departmentCodeList = [];
      const areaName = []
      checkedCodes.map((val) => {
        areaName.push(val.label)
        this.queryForm.departmentCodeList.push(val.value)
      })
      this.queryForm.departmentName = areaName.toString();
    },
    clearDepartment () {
      this.queryForm.departmentCodeList = [];
      this.queryForm.departmentName = '';
    },
    // 获取车辆选择弹框中车辆列表
    getVechileList () {
      const params = {};
      params.plateCode = this.personSearch.plateCode;
      params.name = this.personSearch.name;
      params.personnelType = this.personSearch.personnelType;
      params.beginTime = this.personSearch.modifyTime ? formatTimeToStr(this.personSearch.modifyTime[0]) : "";
      params.endTime = this.personSearch.modifyTime ? formatTimeToStr(this.personSearch.modifyTime[1]) : "";
      params.departmentCodeList = this.queryForm.departmentCodeList;
      params.visitorVehicleTypeCode = this.queryForm.visitorVehicleTypeCode;
      params.pageNum = this.vechilePage.pageNum;
      params.pageSize = this.vechilePage.pageSize;
      this.$fetch(api.vehicle.getVehicleList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.vechileData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.vechilePage.total = response.returnObj
          ? response.returnObj.total
          : 0;
      });
    },
    // 车辆选择确认弹框
    confirmChoose (flag) {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          if (
            this.authorityForm.effectiveTime > this.authorityForm.expirationTime
          ) {
            this.$message({
              type: "warning",
              duration: 2000,
              message: "通行失效时间不可早于通行生效时间",
            });
            return;
          }
          if (this.carIds.length === 0) {
            this.$message({
              type: "warning",
              duration: 2000,
              message: "请选择车辆",
            });
            return;
          }
          let params = {
            thirdDeviceIdList: this.authorityForm.carGate, //闸机的第三方设备ID组
            plateCodeList: this.carIds,
            effectiveTime: this.authorityForm.effectiveTime
              ? Dates.dayjs(this.authorityForm.effectiveTime).format(
                "YYYY-MM-DD HH:mm:ss"
              )
              : "",
            expirationTime: this.authorityForm.expirationTime
              ? Dates.dayjs(this.authorityForm.expirationTime).format(
                "YYYY-MM-DD HH:mm:ss"
              )
              : "",
          };
          if (flag) {
            params.updateFlag = flag
          }
          this.$fetch(api.vehicle.addCarAuthority, params).then((response) => {
            if (!response.success) {
              if (response.msgCode === '103008802010003') {
                // 如果相同的停车场存在授权信息（未失效记录），则提示已经存在XXX人脸的授权信息（有一个提示一个，有多个提示多个），请是否确定覆盖授权
                this.againConfirm(response.msgContent);
              } else {
                this.$message.error(response.msgContent);
                return;
              }
            } else {
              this.$message.success(response.msgContent);
              this.$emit("refreshList")
              this.authorityForm.carGate = [];
              this.linkDialog = false;
            }
          });
        }
      });
    },
    againConfirm (message) {
      this.$confirm(message, "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.confirmChoose(1);
      });
    },
    // 车辆选择取消弹框
    cancleChoose () {
      this.authorityForm.carGate = [];
      this.linkDialog = false;
    },
    carSelection (items) {
      this.carIds = items.map((item) => {
        return item.plateCode;
      });
    },
    // 员工弹框修改每页数据数量
    personChangeSize (val) {
      this.vechilePage.pageNum = 1;
      this.vechilePage.pageSize = val;
      this.getVechileList();
    },
    currentChange (val) {
      this.vechilePage.pageNum = val;
      this.getVechileList();
    },
    searchList (param) {
      this.personSearch = Object.assign(param);
      this.vechilePage.pageNum = 1;
      this.getVechileList();
    },
    carReset () {
      this.queryForm.departmentName = '';
      this.queryForm.departmentCodeList = [];
      this.queryForm.visitorVehicleTypeCode = '';
      this.getVechileList();
    },

  }
}
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.choose-box {
  .el-dialog__body {
    .ioc-table {
      height: 500px;
      .ioc-table__search {
        .el-range-editor {
          width: 360px;
        }
        .tree-container {
          @include set_theme_color(background-color, item-active-bg-color);
          position: absolute;
          bottom: -255px;
          width: 100%;
          z-index: 999999;
          height: 250px;
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.4);
        }
      }
    }
  }
}
</style>
